import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { InventorySessionForm } from '@/pages/inventory/domains/inventory-session';
import { WAREHOUSE_FILTER_TAB_VALUES } from '@/pages/warehouse/shared/warehouse-filter-tabs';
import { getWarehouseReturnUrl } from '@/pages/warehouse/shared/warehouse-sync-url';

const RETURN_URL = getWarehouseReturnUrl(WAREHOUSE_FILTER_TAB_VALUES.INVENTORY);

export const Route = createFileRoute(
  '/protected/_layout/inventory/_layout/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditInventorySessionRoute,
});

function EditInventorySessionRoute() {
  const { id } = Route.useParams();
  return <InventorySessionForm id={id} returnUrl={RETURN_URL} />;
}
